import { render, staticRenderFns } from "./growthSituation.vue?vue&type=template&id=4fa7d8c2&scoped=true"
import script from "./growthSituation.vue?vue&type=script&lang=js"
export * from "./growthSituation.vue?vue&type=script&lang=js"
import style0 from "./growthSituation.vue?vue&type=style&index=0&id=4fa7d8c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7d8c2",
  null
  
)

export default component.exports